import * as types from "./types";
import { loadLanguageAsync } from "../../i18n";
import {
  getTranslations,
  getTranslationsList,
  postUpdate,
  postUpdateAddAll,
  postUpdateAddAllExport,
  postRemove,
  postAdd,
  getAllTranslations,
  getAllTranslationsExport,
  getExportModel
} from "./services";

export async function changeLanguageAction({ commit }, payload) {
  try {
    commit(types.CHANGE_LANGUAGE, payload);
    setTranslationsAction(payload);
  } catch (e) {
    console.log(e);
  }
}

export async function getAllTranslationsAction({ commit }) {
  try {
    return (await getAllTranslations()).data;
  } catch (e) {
    console.log(e);
  }
}

export async function getAllTranslationsExportAction({ commit }) {
  try {
    return (await getAllTranslationsExport()).data;
  } catch (e) {
    console.log(e);
  }
}

export async function setLanguages({ commit }, payload) {
  try {
    payload = ["it-IT", "en-US", "fr-FR" /*, "de-DE", "es-ES", "ru-RU", "zh-CN"*/];
    commit(types.SET_LANGUAGE, payload);
  } catch (e) {
    console.log(e);
  }
}

async function setTranslationsAction(payload) {
  try {
    const { data } = await getTranslations(payload);
    loadLanguageAsync(payload, data);
  } catch (e) {
    console.log(e);
  }
}

export async function getTranslationsAction({ commit }, payload) {
  try {
    return (await getTranslationsList(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function update({ commit }, payload) {
  try {
    await postUpdate(payload);
  } catch (e) {
    console.log(e);
  }
}
export async function updateAddAll({ commit }, payload) {
  try {
    await postUpdateAddAll(payload);
  } catch (e) {
    console.log(e);
  }
}
export async function updateAddAllExport({ commit }, payload) {
  try {
    await postUpdateAddAllExport(payload);
  } catch (e) {
    console.log(e);
  }
}
export async function remove({ commit }, payload) {
  try {
    await postRemove(payload);
  } catch (e) {
    console.log(e);
  }
}
export async function add({ commit }, payload) {
  try {
    await postAdd(payload);
  } catch (e) {
    console.log(e);
  }
}

export async function getExportModelAction({ commit }) {
  try {
    return (await getExportModel()).data;
  } catch (e) {
    console.log(e);
  }
}